import PropTypes from 'prop-types';

export const optionPropTypes = {
  all: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.string,
};

export const propTypes = {
  ...optionPropTypes,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
};

export const optionDefaultProps = {
  all: false,
  onChange: undefined,
  selected: undefined,
};

export const defaultProps = {
  ...optionDefaultProps,
  className: undefined,
};

export const formatOptions = (options, all) => [
  ...(all ? [undefined] : []),
  ...options.filter(option => !!option),
].map(option => ({
  text: option || 'All',
  value: option,
}));
